/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SearchTrigger = {
    Suggestion: 'Suggestion',
    Manual: 'Manual'
} as const;
export type SearchTrigger = typeof SearchTrigger[keyof typeof SearchTrigger];


export function SearchTriggerFromJSON(json: any): SearchTrigger {
    return SearchTriggerFromJSONTyped(json, false);
}

export function SearchTriggerFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchTrigger {
    return json as SearchTrigger;
}

export function SearchTriggerToJSON(value?: SearchTrigger | null): any {
    return value as any;
}

